import { useEffect } from "react";
import debounce from "lodash/debounce";
import { enqueueFirstWinsChatTrigger } from "@/hooks/chat/helpers/chatTriggerCoordinator";

export const useAddressInputTrigger = ({
  enabled,
  timeout = 5,
  popModal,
  triggerChat,
  triggerKey,
  sessionEpoch = 0,
}) => {
  useEffect(() => {
    const debouncedTrigger = debounce(() => {
      enqueueFirstWinsChatTrigger(() => {
        triggerChat("Address Entry", {
          popModal,
          triggerKey,
          ...(!enabled && { isProxyEvent: true }),
        });
      });
    }, timeout * 1000);

    const listener = (event) => {
      if (event?.detail?.resetOnly) {
        debouncedTrigger.cancel();
        return;
      }
      /* Only arm after a successful predictive response with rows; empty/error
      must cancel so a prior "success" debounce cannot still fire chat. */
      if (event?.detail?.suggestions !== true) {
        debouncedTrigger.cancel();
        return;
      }
      debouncedTrigger();
    };

    document.addEventListener("address-input", listener);

    return () => {
      document.removeEventListener("address-input", listener);
      debouncedTrigger.cancel();
    };
  }, [enabled, timeout, popModal, triggerChat, triggerKey, sessionEpoch]);
};
